import {
  ACCESS_TOKEN_KEY,
  COMPANY_ID,
  HAS_COMPANY_LICENCE_RENEWAL_ORDER,
  IS_EXPIRED_RENEWAL,
  IS_REDIRECT_TO_CHANGE_PASSWORD,
  LICENCE_EXPIRY_AT,
  ROLE,
  ROLE_COMPANY_SUPER_ADMIN
} from 'src/constants/auth';
import Cookies from 'js-cookie';
import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { PrivateRouteI } from 'src/models/router';
import { RoutePath } from 'src/enums/routePath';

export const PrivateRoute = ({ children }: PrivateRouteI) => {
  const isLogined = useMemo(() => {
    return !!Cookies.get(ACCESS_TOKEN_KEY);
  }, []);

  const isRedirectToChangePassword = localStorage.getItem(
    IS_REDIRECT_TO_CHANGE_PASSWORD
  );

  const isExpiredRenewal = localStorage.getItem(IS_EXPIRED_RENEWAL);
  const companyId = localStorage.getItem(COMPANY_ID);

  const today = new Date();
  const licenceExpiryAt = new Date(
    localStorage.getItem(LICENCE_EXPIRY_AT) || ''
  );
  const isCompanySuperAdmin =
    Number(localStorage.getItem(ROLE)) === ROLE_COMPANY_SUPER_ADMIN;
  const isExpired =
    licenceExpiryAt &&
    today?.valueOf() > licenceExpiryAt.valueOf() &&
    isCompanySuperAdmin;
  const isRequiredRenewal =
    (isCompanySuperAdmin &&
      localStorage.getItem(HAS_COMPANY_LICENCE_RENEWAL_ORDER) !== 'null') ||
    isExpired;
  if (isLogined) {
    if (isRedirectToChangePassword === 'true') {
      return <Navigate to={RoutePath.CHANGE_PASSWORD} replace />;
    } else if (isExpiredRenewal === 'true' || isRequiredRenewal) {
      return (
        <Navigate
          to={`${RoutePath.COMPANY}${RoutePath.DETAIL}/${companyId}`}
          replace
        />
      );
    } else {
      return children;
    }
  } else {
    return <Navigate to={RoutePath.LOGIN} replace />;
  }

  // return isLogined ? children : <Navigate to={RoutePath.LOGIN} replace />;
};
